<div class="contenedor-importante">
    <div class="contenedor-importante-icono">
        <ion-icon class="i-info-fill-2"></ion-icon>
    </div>
    <div class="contenedor-importante-textos">
        <div class="contenedor-importante-titulo">
            <h1>Importante</h1>
        </div>
        <ng-container *ngIf="tipo === tipoDetalleBeneficios">
            <p class="ion-no-margin">Es fundamental que los potenciales beneficiarios mantengan <a
                    (click)="irViaDePago()">vía de pago actualizada</a> a fin de que puedan acceder sin inconvenientes y
                con mayor rapidez.<br><br>Si quieres conocer más sobre y otros beneficios, te invitamos a revisar el
                siguiente video en <a (click)="irCapitalPlay()">Capital Play.</a></p>
        </ng-container>
        <ng-container *ngIf="tipo === tipoBeneficios">
            <ul class="ion-no-margin" *ngIf="mostrarComoLista">
                <li *ngIf="mostrarTextoMontoUF">
                    El monto dependerá del valor de la UF del primer día del mes del pago y es preliminar, previo a la
                    concesión del Instituto de Previsión Social (IPS).
                </li>
                <li>
                    La adjudicación de los beneficios de la reforma es determinada por el IPS.
                </li>
            </ul>
            <p class="ion-no-margin" *ngIf="!mostrarComoLista">
                La adjudicación de los beneficios de la reforma es determinada por el IPS.
            </p>
        </ng-container>
    </div>
</div>